export default "__VITE_ASSET__Doso5CY___"